/**
 * EMU Invoice API
 * EMU Invoice API documentation<br> Do not use 403 status, use 409 instead<br>
 *
 * OpenAPI spec version: 1.0.5
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { DbDefaultResponse } from '../model/dbDefaultResponse';
import { InvoiceTemplateDto } from '../model/invoiceTemplateDto';
import { InvoiceTemplateListResponseDto } from '../model/invoiceTemplateListResponseDto';
import { InvoiceTemplateSaveDto } from '../model/invoiceTemplateSaveDto';
import { ListFilterRequestDto } from '../model/listFilterRequestDto';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable()
export class InvoiceTemplateService {
  protected basePath = 'http://127.0.0.1:4201/api/';

  public defaultHeaders = new HttpHeaders();

  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration,
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   *
   *
   * @param id
   * @param x_organization
   * @param x_apigateway_event
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public invoiceTemplateControllerDelete(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<DbDefaultResponse>;
  public invoiceTemplateControllerDelete(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<DbDefaultResponse>>;
  public invoiceTemplateControllerDelete(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<DbDefaultResponse>>;
  public invoiceTemplateControllerDelete(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling invoiceTemplateControllerDelete.',
      );
    }

    let headers = this.defaultHeaders;
    if (x_organization !== undefined && x_organization !== null) {
      headers = headers.set('x-organization', String(x_organization));
    }
    if (x_apigateway_event !== undefined && x_apigateway_event !== null) {
      headers = headers.set('x-apigateway-event', String(x_apigateway_event));
    }

    // authentication (bearer) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<DbDefaultResponse>(
      'delete',
      `${this.basePath}/invoice-template/${encodeURIComponent(String(id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   *
   *
   * @param id
   * @param x_organization
   * @param x_apigateway_event
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public invoiceTemplateControllerGet(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<InvoiceTemplateDto>;
  public invoiceTemplateControllerGet(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<InvoiceTemplateDto>>;
  public invoiceTemplateControllerGet(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<InvoiceTemplateDto>>;
  public invoiceTemplateControllerGet(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling invoiceTemplateControllerGet.',
      );
    }

    let headers = this.defaultHeaders;
    if (x_organization !== undefined && x_organization !== null) {
      headers = headers.set('x-organization', String(x_organization));
    }
    if (x_apigateway_event !== undefined && x_apigateway_event !== null) {
      headers = headers.set('x-apigateway-event', String(x_apigateway_event));
    }

    // authentication (bearer) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<InvoiceTemplateDto>(
      'get',
      `${this.basePath}/invoice-template/${encodeURIComponent(String(id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   *
   *
   * @param id
   * @param x_organization
   * @param x_apigateway_event
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public invoiceTemplateControllerGetDefault(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<InvoiceTemplateDto>;
  public invoiceTemplateControllerGetDefault(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<InvoiceTemplateDto>>;
  public invoiceTemplateControllerGetDefault(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<InvoiceTemplateDto>>;
  public invoiceTemplateControllerGetDefault(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling invoiceTemplateControllerGetDefault.',
      );
    }

    let headers = this.defaultHeaders;
    if (x_organization !== undefined && x_organization !== null) {
      headers = headers.set('x-organization', String(x_organization));
    }
    if (x_apigateway_event !== undefined && x_apigateway_event !== null) {
      headers = headers.set('x-apigateway-event', String(x_apigateway_event));
    }

    // authentication (bearer) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<InvoiceTemplateDto>(
      'get',
      `${this.basePath}/invoice-template/default/${encodeURIComponent(String(id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   *
   *
   * @param body
   * @param x_organization
   * @param x_apigateway_event
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public invoiceTemplateControllerList(
    body: ListFilterRequestDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<InvoiceTemplateListResponseDto>;
  public invoiceTemplateControllerList(
    body: ListFilterRequestDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<InvoiceTemplateListResponseDto>>;
  public invoiceTemplateControllerList(
    body: ListFilterRequestDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<InvoiceTemplateListResponseDto>>;
  public invoiceTemplateControllerList(
    body: ListFilterRequestDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling invoiceTemplateControllerList.',
      );
    }

    let headers = this.defaultHeaders;
    if (x_organization !== undefined && x_organization !== null) {
      headers = headers.set('x-organization', String(x_organization));
    }
    if (x_apigateway_event !== undefined && x_apigateway_event !== null) {
      headers = headers.set('x-apigateway-event', String(x_apigateway_event));
    }

    // authentication (bearer) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<InvoiceTemplateListResponseDto>(
      'post',
      `${this.basePath}/invoice-template/list`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Set counter template
   *
   * @param body
   * @param x_organization
   * @param x_apigateway_event
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public invoiceTemplateControllerSave(
    body: InvoiceTemplateSaveDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<any>;
  public invoiceTemplateControllerSave(
    body: InvoiceTemplateSaveDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<any>>;
  public invoiceTemplateControllerSave(
    body: InvoiceTemplateSaveDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<any>>;
  public invoiceTemplateControllerSave(
    body: InvoiceTemplateSaveDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling invoiceTemplateControllerSave.',
      );
    }

    let headers = this.defaultHeaders;
    if (x_organization !== undefined && x_organization !== null) {
      headers = headers.set('x-organization', String(x_organization));
    }
    if (x_apigateway_event !== undefined && x_apigateway_event !== null) {
      headers = headers.set('x-apigateway-event', String(x_apigateway_event));
    }

    // authentication (bearer) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = [];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<any>('post', `${this.basePath}/invoice-template`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
